module.exports = __webpack_public_path__ + "img/sustainabilityGold@2x.2e4e33c.webp";